import { createRemoteComponent } from '@remote-ui/core';

/**
 * Use banners to communicate important messages to customers in a prominent way.
 */
const Banner = createRemoteComponent('Banner');

export { Banner };
